import Vue from 'vue'

export default ({ }, inject) => {
  const state = Vue.observable({
    activeIndexes: {},
    setArrayLength (length:number) {
      // state.activeIndexes = new Array(length).fill(false)
    },
    toggleActive (id: number, index: number) {
      Vue.set(state.activeIndexes, id, { ...state.activeIndexes?.[id], [index]: !state.activeIndexes?.[id]?.[index] })
    }
  })

  // Регистрируем переменную и метод в прототипе Vue
  inject('faq', state)
}
